// extracted by mini-css-extract-plugin
export default {"container":"WishLists_container__4lD7V","wishlistBanner":"WishLists_wishlistBanner__+JnHj"};